export default __webpack_public_path__ + "static/media/interest.584aaf0c.svg";